import { useTranslation as e } from "../../../i18n.mjs";
import { toast as t } from "../../../components/toast/index.mjs";
import { useFileUploaderActions as n } from "./use-file-uploader-actions.mjs";
import { createCanceler as r } from "../utils/create-canceler.mjs";
import { createProgress as i } from "../utils/create-progress.mjs";
import { getMimeType as a } from "../utils/get-mime-type.mjs";
import o from "axios";
//#region src/modules/file-uploader/hooks/use-file-uploader.ts
var s = (s) => {
	let { t: c } = e(), { validateAndGetUploadOptions: l, uploadToFileStore: u, activate: d, removeDraftFile: f } = n(s);
	return { createFileUploader: (e) => {
		let n = i(e), s = r();
		return {
			progress: n,
			upload: async ({ file: e, source: r }) => {
				n.startProgress();
				let i = s.createToken(), p;
				try {
					let { uploadOptions: t, id: o } = await l({
						file: e,
						source: r,
						mimeType: a(e),
						cancelToken: i
					});
					p = o, await u({
						file: e,
						uploadOptions: t,
						progressHandler: n.progressHandler,
						cancelToken: i
					});
					let s = await d({
						fileId: o,
						cancelToken: i
					});
					return n.finishProgress(), s[o];
				} catch (n) {
					if (o.isCancel(n)) {
						t(c("file_manager.cancelled", { name: e.name })), typeof p == "number" && await f(p);
						return;
					}
					throw typeof p == "number" && await f(p), n;
				}
			},
			cancelUpload: () => {
				s.cancel(), n.resetProgress();
			}
		};
	} };
};
//#endregion
export { s as useFileUploader };
